import * as React from 'react';

import { rgba } from 'polished';
import styled, { css } from 'styled-components';

interface ModalBackgroundProps {
  className?: string;
  children?: React.ReactNode;
  active: boolean;
  zIndex?: number;
}

export const ModalBackground: React.FC<ModalBackgroundProps> = (props) => {
  return (
    <div className={props.className}>
      <div className="modal-children">{props.children}</div>
    </div>
  );
};

export default styled(ModalBackground)`
  pointer-events: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  background: ${({ theme }) => rgba(theme.colors.background, 0.5)};
  transition: opacity
    ${({ theme }) => `${theme.transitions.duration} ${theme.transitions.type}`};
  z-index: ${(props) =>
    props.zIndex
      ? props.zIndex
      : css`
          ${({ theme }) => theme.zIndices.modal}
        `};

  .modal-children {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  ${(props) =>
    props.active
      ? `
    opacity: 1;
    pointer-events: initial;
  `
      : null}
`;
